require('./style.less');

var ShapeToolbarView = require('../shapeToolbar');

module.exports = ShapeToolbarView.extend({
    template: require('./redactionTypeToolbar.hbs'),
    id: 'redactTypeTB',
    ui: _.extend({}, ShapeToolbarView.prototype.ui, {
        polyRedactBtn: '#polyRedactBtn'
    }),
    render: function() {
        ShapeToolbarView.prototype.render.call(this);
        this.options.pageIsCold && this.ui.polyRedactBtn.addClass('hide'); //don't allow poly redactions for cold pages
        return this;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/header/shapeDrawingToolbars/redactionTB/redactionToolbar.js
 ** module id = 500
 ** module chunks = 0
 **/